/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewSupplyChainMembersFromExcelRequest } from '../../models/new-supply-chain-members-from-excel-request';

export interface NewSupplyChainMembersFromExcel$FormData$Params {
      body?: {
'request': NewSupplyChainMembersFromExcelRequest;
}
}

export function newSupplyChainMembersFromExcel$FormData(http: HttpClient, rootUrl: string, params?: NewSupplyChainMembersFromExcel$FormData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, newSupplyChainMembersFromExcel$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

newSupplyChainMembersFromExcel$FormData.PATH = '/api/supply-chain/members/from-excel';
